import React from 'react'

import { classnames, Icon, AttentionOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf, string } from 'prop-types'

function SubscriptionStatusNotice({
  tone = 'neutral', title, text, linkHref, linkLabel,
}) {
  return (
    <div className={classnames('subscription-status-notice', `subscription-status-notice--${tone}`)}>
      <Icon
        svgComponent={AttentionOutlined}
        className={classnames('subscription-status-notice__icon', `subscription-status-notice__icon--${tone}`)}
        notSpaced
      />
      <div className="subscription-status-notice__content">
        <p className="subscription-status-notice__title cgt-body-md-semibold">{title}</p>
        <p className="subscription-status-notice__text cgt-body-base">{text}</p>
        <a href={linkHref} className="subscription-status-notice__link cgt-link-primary">{linkLabel}</a>
      </div>
    </div>
  )
}

SubscriptionStatusNotice.propTypes = {
  tone: oneOf(['neutral', 'error']),
  title: string.isRequired,
  text: string.isRequired,
  linkHref: string.isRequired,
  linkLabel: string.isRequired,
}

export default SubscriptionStatusNotice
